import { useReducer, useEffect } from 'react';

function reducer(currentSrc, action) {
  if (action.type === 'IMAGE_LOADED') {
    return action.src;
  }
  if (!currentSrc) {
    return action.src;
  }
  return currentSrc;
}

const useProgressiveImage = ({ src, fallbackSrc }) => {
  const [currentSrc, dispatch] = useReducer(reducer);
  useEffect(() => {
    const started = Date.now();
    const mainImage = new Image();
    const fallbackImage = new Image();

    mainImage.onload = () => {
      dispatch({ type: 'IMAGE_LOADED', src });
      console.log(
        `[Image] ${src} - completed after: ${Date.now() - started}ms`
      );
    };
    fallbackImage.onload = () => {
      dispatch({ type: 'IMAGE_FAILED', src: fallbackSrc });
      console.log(`[Image] ${src} - failed after: ${Date.now() - started}ms`);
    };

    mainImage.src = src;
    fallbackImage.src = fallbackSrc;
  }, [src, fallbackSrc]);

  return currentSrc;
};

export default useProgressiveImage;
